/**
 * Base64 unpadded length calculation
 * Learn more: https://developer.mozilla.org/en-US/docs/Glossary/Base64
 */
export default function calculateBase64Size(sizeInBytes) {
  return (4 * sizeInBytes) / 3;
}
